/**
 * YD Image Format Detector
 * AVIF/WebP 格式支持检测工具
 */
window.imageFormatDetector = (function() {
  const cache = {};

  /**
   * 检测浏览器是否支持指定格式
   * @param {string} format - 'avif' | 'webp'
   * @returns {Promise<boolean>}
   */
  async function isSupported(format) {
    if (cache[format] !== undefined) {
      return cache[format];
    }

    const testImages = {
      avif: 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKBzgADlAgIGkyCR/wAABAAACvcA==',
      webp: 'data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA=='
    };

    if (!testImages[format]) {
      console.warn(`[imageFormatDetector] Unknown format: ${format}`);
      return false;
    }

    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        cache[format] = true;
        resolve(true);
      };
      img.onerror = () => {
        cache[format] = false;
        resolve(false);
      };
      img.src = testImages[format];
    });
  }

  /**
   * 获取最佳支持格式
   * @returns {Promise<string>} - 'avif' | 'webp' | 'png'
   */
  async function getBestFormat() {
    if (await isSupported('avif')) return 'avif';
    if (await isSupported('webp')) return 'webp';
    return 'png';
  }

  return {
    isSupported,
    getBestFormat
  };
})();
